import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { pageStyles } from "../../theme";

export const useStyles = makeStyles((theme: Theme) => ({
  ...pageStyles(theme),
  root: {},
  section: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
    color: theme.palette.primary.main,
    [theme.breakpoints.down("md")]: {
      paddingTop: 0,
    },
  },
  sectionTitle: {
    fontSize: theme.spacing(5),
    fontWeight: 600,
    paddingBottom: theme.spacing(2.5),
  },
  sectionSubTitle: {
    fontSize: 25,
    fontWeight: 600,
    color: "#000",
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  sectionText: {
    fontSize: 20,
    color: "#000",
  },
  sectionDivider: {
    height: 2,
    width: "100%",
    backgroundColor: theme.palette.primary.main,
  },
  imageContainer: {
    maxHeight: theme.spacing(60),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",

    [theme.breakpoints.down("md")]: {
      minHeight: theme.spacing(45),
      height: theme.spacing(45),
    },
  },
  heroImage: {
    width: "100%",

    [theme.breakpoints.down("md")]: {
      width: "auto",
      maxWidth: "none",
      height: "100%",
    },
  },
}));
